export default class DetalleDeSolicitudPadron{

    constructor(){
        this.EsValido = false;
        this.Errores = [];
        this.Solicitud = [];
    }


    EsValido:boolean;
    Errores:any;
    Solicitud: any;

}